export const inputFieldsTop = [
    { name: "ftm_forename", label: "First Name", placeholder: "First Name", type: "text" },
    { name: "ftm_surname", label: "Last Name", placeholder: "Last Name", type: "text" },
];

export const inputFieldsMid = [
    { name: "ftm_email", label: "Email", placeholder: "Email", type: "text" },
];

export const inputFieldsDOB = [
    { name: "ftm_birth_of_date", label: "Date of birth", placeholder: "Date of birth", type: "date" },
];

export const inputFieldsPassword = [
    { name: "ftm_password", label: "Password", placeholder: "Password", type: "password" },
    { name: "ftm_confirm_password", label: "Confirm password", placeholder: "Confirm password", type: "password" },
];